import TableBody from '@material-ui/core/TableBody';
import * as React from 'react';
import { ISearchResult } from '../SearchBar';
import { ITableHeader } from '../SmartTable';
import IRow from './IRow';
import SmartTableRow from './SmartTableRow';

interface ISmartTableBody<T> {
  headers: Array<ITableHeader<T>>
  rows: Array<ISearchResult<T>>
  alternatingColors: [string, string] | undefined
}

export default class SmartTableBody<T extends IRow> extends React.PureComponent<ISmartTableBody<T>, {}> {
  public render() {
    const {
      alternatingColors,
      rows,
      headers,
    } = this.props;
    let offset = 0;
    return (
      <TableBody>
        {rows.map((content: ISearchResult<T>, i: number) => {
          // If the content will not be shown, switch over to the next color
          offset = content.show && !offset ? 0 : 1;
          return <SmartTableRow
            color={alternatingColors ? alternatingColors[(i + offset)%2]: 'white'}
            key={content.item.id}
            headers={headers}
            content={content}/>
        }

        )}
      </TableBody>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/smartTable/SmartTableBody.tsx